import React from "react"
import * as d3 from "d3"
import { Flex, useTheme } from "@chakra-ui/react"
import { BIKE_MARKER_COLORS } from "../lib/static/bike"
import {
  CLUSTER_MARKER_INNER_RADIUS,
  CLUSTER_MARKER_OUTER_RADIUS,
  CLUSTER_MARKER_PIE_SIZE,
  getStateModeColor,
} from "../lib/helpers/clusters"

interface Props {
  count: number
  uuids: string[]
  stateCounts: { [key: string]: number }
  onClick?: () => void
}

export function AlertsClusterMarker(props: Props) {
  const theme = useTheme()
  const data = Object.values(props.stateCounts)
  const states = Object.keys(props.stateCounts)
  const colors = states.map(
    (state) => theme.colors[BIKE_MARKER_COLORS[!!state ? state : "unknown"]]["400"] || "gray.400",
  )

  return (
    <Flex
      as="button"
      overflow="hidden"
      align="center"
      justify="center"
      bg={getStateModeColor(props.stateCounts, theme)}
      cursor="pointer"
      borderRadius="50%"
      onClick={props.onClick}
    >
      <Flex
        pos="absolute"
        align="center"
        justify="center"
        top={0}
        left={0}
        right={0}
        bottom={0}
        color="white"
        fontWeight="600"
      >
        {props.count}
      </Flex>
      <Pie
        size={CLUSTER_MARKER_PIE_SIZE}
        innerRadius={CLUSTER_MARKER_INNER_RADIUS}
        outerRadius={CLUSTER_MARKER_OUTER_RADIUS}
        {...{ data, colors }}
      />
    </Flex>
  )
}

const Pie = (props: {
  size: number
  innerRadius: number
  outerRadius: number
  data: number[]
  colors: string[]
}) => {
  const data = d3.pie<number>().value((d) => d)(props.data)
  const createArc = d3.arc().innerRadius(props.innerRadius).outerRadius(props.outerRadius)

  return (
    <svg width={props.size} height={props.size}>
      <g transform={`translate(${props.outerRadius} ${props.outerRadius})`}>
        {data.map((d, i) => (
          <g key={i}>
            <path
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              d={createArc(d)}
              fill={props.colors[i]}
            />
          </g>
        ))}
      </g>
    </svg>
  )
}
